import { put, takeEvery } from 'redux-saga/effects'
import { delay } from 'redux-saga'

import Cookies from 'js-cookie'
import { makePushEvent } from '@devicebits/analytics-client'
import Raven from 'raven-js'

import { CREATE_USER_EVENT } from './constants'
import { getSessionId, getPermanentId, getAppInstanceId } from '../../helpers'
import { getCustomer } from '../../helpers'
import { getParam } from '../../helpers/parameters'
import * as KEYS from '../../constants/keys'

const appStartTime = new Date()

const analyticsBaseProps = {
  app_instance_time: () => (new Date() - appStartTime).toString(),
  page: () => ({
    url: window.location.href
  }),
  user_agent: navigator.userAgent,
  timestamp: () => new Date().toISOString(),
  session_id: getSessionId(),
  permanent_id: getPermanentId(),
  user_id: () => localStorage.getItem(KEYS.AUTH_USER_ID),
  user_email: () => localStorage.getItem(KEYS.AUTH_USER_EMAIL),
  customer: getCustomer,
  call_session_id: () => sessionStorage.getItem(KEYS.CALL_SESSION_ID),
}

const analyticsApiUrlPromise = getParam('analyticsApiUrl')

const getAnalyticsApiUrl = async () => {
  const url = await analyticsApiUrlPromise
  return `${url}/analytics/careAssist`
}

// TODO why is there an acad push event here?
const getAnalyticsApiUrlAcademy = async () => {
  const url = await analyticsApiUrlPromise
  return `${url}/analytics/academy`
}

const pushEvent = makePushEvent({
  apiUrl: getAnalyticsApiUrl(),
  debounceDelay: 5000,
  baseProps: analyticsBaseProps
})

const pushEventAcademy = makePushEvent({
  apiUrl: getAnalyticsApiUrlAcademy(),
  debounceDelay: 5000,
  baseProps: analyticsBaseProps
})

function* eventWorker(action) {
  const customer = getCustomer()

  // put action back to redux when customer is not yet resolved to retry after delay
  if (!customer) {
    yield delay(1000)
    return yield put(action)
  }

  const {
    event: { data, category }
  } = action

  const userEvent =
    { ...data, app_instance_id: getAppInstanceId, event_category: category } ||
    {}

  // device_id is off-schema for kendrasearch table
  if (category !== 'kendrasearch') {
    userEvent.device_id =  () => Cookies.get(KEYS.DEVICE_ID) || null
  }

  pushEvent({
    category,
    data: {
      ...userEvent,
      // referrer in pageview only
      referrer:
        category === 'pageviews' ? { url: window.location.href } : undefined
    }
  }).catch((err) => {
    console.error('Events send to analytics failed', err)
    Raven.captureException(err)
  })

  if (['faqs', 'tutorials'].includes(category)) {
    pushEventAcademy({
      category,
      data: { ...userEvent }
    }).catch((err) => {
      console.error('Events send to Academy analytics failed', err)
      Raven.captureException(err)
    })
  }
}

export default function* watcher() {
  yield takeEvery(CREATE_USER_EVENT, eventWorker)
}
